import customTools from 'src/js/modules/custom-tools';
import common from './constants/common';
import supportedBlockIds from './constants/supported-block-ids';
import createLayoutControl from './controls/create-layout-control';
import duplicateCompositeItemControl from './controls/duplicate-composite-item-control';
import layerForwardControl from './controls/layer-forward-control';
import layerBackwardControl from './controls/layer-backward-control';
import tools from './tools';
import selectLayerControl from './controls/select-layer-control';
import addAndConvertToGroupControl from './controls/add-and-convert-to-group-control';

const getExtension = () => ({
  slug: common.slug,
  title: 'WS Composite Group extensions',
  description: 'Extension to setup composite group',
  settings: {
    querySelector: 'ws-composite-group, ws-composite-item',
    elementToReorderSelector: 'ws-composite-item',
    supportedBlockIds,
  },
  ui: {
    control: [
      addAndConvertToGroupControl,
      createLayoutControl,
      duplicateCompositeItemControl,
      layerForwardControl,
      layerBackwardControl,
      selectLayerControl,
    ],
  },
  init() {
    customTools.operations.registerTool(tools.stretchToolSettings);
  },
});

export default getExtension;
